import { Color } from "@starrez/starryui";
import * as React from "react";
import { IFullScreenModalProps } from ".";
import { strings } from "../../localisation";
import { BaseModal } from "./BaseModal";

const FullScreenModal = ({
    children,
    CloseAriaLabel = strings.Action_CloseEmailWizard,
    CloseTitle = strings.Action_CloseEmailWizard,
    Header,
    ListenToBackgroundClick = true,
    OnCloseRequest,
    RenderFooter,
    DisableClose,
}: IFullScreenModalProps) => {

    return (
        <BaseModal
            BorderRadius={"0px"}
            CloseAriaLabel={CloseAriaLabel}
            CloseTitle={CloseTitle}
            FooterColor={Color.Grey.G20}
            Header={Header}
            ListenToBackgroundClick={ListenToBackgroundClick}
            OnCloseRequest={OnCloseRequest}
            RenderFooter={RenderFooter}
            Width={"100%"}
            Height={"100%"}
            DisableClose={DisableClose}
        >
            {children}
        </BaseModal>
    );
};

export default FullScreenModal;
